// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { observer } from "mobx-react-lite";

import { palette } from "~design-system";

import { useTypesenseStore } from "../../../../components/StoreProvider";
import { SectionCardHeader } from "../../../SectionCard";
import {
  InfoBadge,
  InfoBadgeDetail,
  InfoBadgeLabel,
  StatusCardBody,
  StatusDot,
  StatusLabel,
  StatusRow,
  TypesenseCard,
} from "../styles";
import { envLabel } from "../util";

function dotColor(healthy: boolean) {
  return healthy ? palette.pine3 : palette.signal.error;
}

export const StatusCard = observer(function StatusCard() {
  const store = useTypesenseStore();
  const { host, checkedAt } = store;

  return (
    <TypesenseCard>
      <SectionCardHeader>Status</SectionCardHeader>
      <StatusCardBody>
        <StatusRow>
          <StatusDot $color={dotColor(true)} />
          <StatusLabel $color={dotColor(true)}>Healthy</StatusLabel>
        </StatusRow>

        {host && (
          <InfoBadge>
            <InfoBadgeLabel>Environment: {envLabel(host)}</InfoBadgeLabel>
            <InfoBadgeDetail>{host}</InfoBadgeDetail>
          </InfoBadge>
        )}

        {checkedAt && (
          <span>Last checked: {checkedAt.toLocaleTimeString()}</span>
        )}
      </StatusCardBody>
    </TypesenseCard>
  );
});
